import { getContext, setContext } from 'svelte';
export const globalContextName = 'adofaigg-ui-global-context';
export const setGlobalContext = (context) => setContext(globalContextName, context);
export const getGlobalContext = () => getContext(globalContextName);
